import { render, staticRenderFns } from "./badgeCategory.vue?vue&type=template&id=28bb5a58&scoped=true&"
import script from "./badgeCategory.vue?vue&type=script&lang=js&"
export * from "./badgeCategory.vue?vue&type=script&lang=js&"
import style0 from "./badgeCategory.vue?vue&type=style&index=0&id=28bb5a58&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bb5a58",
  null
  
)

export default component.exports